<template>
  <common-dialog
    ref="dialog"
    width="1400px"
    title="流程节点设置"
    :data="data"
    @create-opened="onCreateOpened"
    @edit-opened="onEditOpened"
    :form-rules="rules"
    @opened="onOpened"
    @closed="onClosed"
  >
    <template slot="form">
      <el-form-item label="流程名称" prop="ProcessName" label-width="110px">
        <el-input type="text" v-model="data.ProcessName" placeholder="请输入流程名称"></el-input>
      </el-form-item>
      <el-form-item label="流程描述" prop="Description" label-width="110px">
        <el-input type="text" v-model="data.Description" placeholder="请输入流程描述"></el-input>
      </el-form-item>
      <div>
        <div class="form-item">
          <el-form-item label="状态" prop="Status" label-width="110px">
            <el-select v-model="data.Status">
              <el-option :value="1" label="启用"></el-option>
              <el-option :value="0" label="停用"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item label="序号" prop="Sort" label-width="110px">
            <el-input-number v-model="data.Sort" v-int :step="1" :min="0"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item" v-if="isEdit">
          <el-form-item prop="VersionId" label-width="110px">
            <template slot="label">
              <span style="margin-right: 5px;">历史版本</span>
              <el-tooltip effect="dark" placement="top">
                <div slot="content" v-html="TopTip"></div>
                <i class="el-icon-question" />
              </el-tooltip>
            </template>
            <el-select v-model="data.VersionId" @change="onReload">
              <template v-for="(i,key) in data.History">
                <el-option :key="key" :value="i.VersionId" :label="i.VersionText"></el-option>
              </template>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="form-item" v-for="(i,key) in data.Version.Configs" :key="key">
        <el-form-item :label="i.ConfigName" label-width="110px">
          <template v-if="i.ConfigType==101">
            <el-input type="text" v-model="i.ConfigValue" v-int>
              <span slot="append">天</span>
            </el-input>
          </template>
          <template v-if="i.ConfigType==300">
            <el-select v-model="i.ConfigValue">
              <template v-for="(ci,ckey) in i.OptionArr">
                <el-option :key="ckey" :value="ci" :label="ci"></el-option>
              </template>
            </el-select>
          </template>
        </el-form-item>
      </div>
      <div class="index-tree-box">
        <div class="left-box" style="height: auto;width: 360px;">
          <node-tree ref="nodeTree" height="700px" @select="onSelect" />
        </div>
        <div class="right-box">
          <template v-if="select.TreeNodeId!=null">
            <template v-if="select.TreeNodeType==0">
              <el-form-item label="节点名称" style="margin: 0;" v-if="select.Node.NodeType!=98">
                <el-input v-model="select.Node.NodeName" placeholder="请输入节点名称"></el-input>
              </el-form-item>
            </template>
            <el-form-item label="节点名称" style="margin: 0;" v-else>
              <span v-if="select.Flow.IsDefault">{{select.Flow.FlowName}}</span>
              <el-input v-else v-model="select.Flow.FlowName" placeholder="请输入节点名称"></el-input>
            </el-form-item>
            <template v-if="select.TreeNodeType==0">
              <el-divider style="margin: 11px 0px;" v-if="select.Node.NodeType!=98"></el-divider>
              <div v-if="select.Node.NodeType==0||select.Node.NodeType==98">
                <div class="row-tb-head">
                  <el-dropdown trigger="click" @command="onCommand">
                    <el-button type="primary" style="float: right;">添 加</el-button>
                    <el-dropdown-menu slot="dropdown" style="width: 60px;text-align: center;">
                      <el-dropdown-item :command="0" style="line-height: 28px;">人员</el-dropdown-item>
                      <el-dropdown-item :command="1" style="line-height: 28px;">部门</el-dropdown-item>
                      <el-dropdown-item :command="2" style="line-height: 28px;">职务</el-dropdown-item>
                      <el-dropdown-item :command="3" style="line-height: 28px;">标签</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <el-table :data="select.Members" border>
                  <el-table-column prop="MemberName" label="名称" />
                  <el-table-column prop="MemberType" label="类型" width="90">
                    <template slot-scope="{row}">
                      <span v-if="row.MemberType==0">人员</span>
                      <span v-if="row.MemberType==1">部门</span>
                      <span v-if="row.MemberType==2">职务</span>
                      <span v-if="row.MemberType==3">标签</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="60">
                    <template slot-scope="{row,$index}">
                      <el-button @click="delMember(row,$index)" type="text">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div v-if="select.Node.NodeType==1||select.Node.NodeType==2">
                <div style="margin-bottom: 20px;">
                  <el-radio v-model="select.Node.BaseMode" :label="0">指定维度</el-radio>
                  <el-radio v-model="select.Node.BaseMode" :label="1">指定部门负责人</el-radio>
                  <el-radio v-model="select.Node.BaseMode" :label="2">连续多级部门负责人</el-radio>
                  <el-radio v-model="select.Node.BaseMode" :label="3">申请人本人</el-radio>
                  <el-radio v-model="select.Node.BaseMode" :label="99">指定条件</el-radio>
                </div>
                <template v-if="select.Node.BaseMode==0">
                  <div class="row-tb-head">
                    <el-dropdown trigger="click" @command="onCommand">
                      <el-button type="primary" style="float: right;">添 加</el-button>
                      <el-dropdown-menu slot="dropdown" style="width: 60px;text-align: center;">
                        <el-dropdown-item :command="0" style="line-height: 28px;">人员</el-dropdown-item>
                        <el-dropdown-item :command="1" style="line-height: 28px;">部门</el-dropdown-item>
                        <el-dropdown-item :command="2" style="line-height: 28px;">职务</el-dropdown-item>
                        <el-dropdown-item :command="3" style="line-height: 28px;">标签</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <el-table :data="select.Members" border>
                    <el-table-column prop="MemberName" label="名称" />
                    <el-table-column prop="MemberType" label="类型" width="90">
                      <template slot-scope="{row}">
                        <span v-if="row.MemberType==0">人员</span>
                        <span v-if="row.MemberType==1">部门</span>
                        <span v-if="row.MemberType==2">职务</span>
                        <span v-if="row.MemberType==3">标签</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="60">
                      <template slot-scope="{row,$index}">
                        <el-button @click="delMember(row,$index)" type="text">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <template v-if="select.Node.BaseMode==1">
                  <div class="row-tb-head">
                    <span style="font-weight: bold;">指定层级</span>
                  </div>
                  <div>
                    <el-select v-model="select.Node.DirectorDirection" @change="setDirector">
                      <el-option label="从下至上" :value="0"></el-option>
                      <el-option label="从上至下" :value="1"></el-option>
                    </el-select>
                    <div style="display: inline-block;width: 10px;"></div>
                    <el-select v-model="select.Node.DirectorLv" @change="setDirector">
                      <template v-if="select.Node.DirectorDirection==0">
                        <el-option label="直接部门负责人" :value="1"></el-option>
                        <template v-for="(i,key) in LvList">
                          <el-option :key="key" :label="i.label+'级部门负责人'" :value="i.value"></el-option>
                        </template>
                      </template>
                      <template v-else>
                        <el-option label="最高部门负责人" :value="1"></el-option>
                        <template v-for="(i,key) in LvList">
                          <el-option :key="key" :label="i.label+'层部门负责人'" :value="i.value"></el-option>
                        </template>
                      </template>
                    </el-select>
                  </div>
                </template>
                
                <template v-if="select.Node.BaseMode==2">
                  <div class="row-tb-head">
                    <span style="font-weight: bold;">指定终点</span>
                    <span style="margin-left: 10px;">将从申请人的直接部门负责人依次审批到此部门负责人为止</span>
                  </div>
                  <div>
                    <el-select v-model="select.Node.DirectorDirection" @change="setDirector">
                      <el-option label="从下至上" :value="0"></el-option>
                      <el-option label="从上至下" :value="1"></el-option>
                    </el-select>
                    <div style="display: inline-block;width: 10px;"></div>
                    <el-select v-model="select.Node.DirectorLv" @change="setDirector">
                      <template v-if="select.Node.DirectorDirection==0">
                        <el-option label="直接部门负责人" :value="1"></el-option>
                        <template v-for="(i,key) in LvList">
                          <el-option :key="key" :label="i.label+'级部门负责人'" :value="i.value"></el-option>
                        </template>
                      </template>
                      <template v-else>
                        <el-option label="最高部门负责人" :value="1"></el-option>
                        <template v-for="(i,key) in LvList">
                          <el-option :key="key" :label="i.label+'层部门负责人'" :value="i.value"></el-option>
                        </template>
                      </template>
                    </el-select>
                  </div>
                </template>
                
                <template v-if="select.Node.BaseMode==99">
                  <div style="margin-bottom: 5px;">
                    <el-button type="primary" plain @click="addCondition">添加条件</el-button>
                  </div>
                  <div v-for="(i,key) in select.MemberConditions" :key="key" class="conditions">
                    <div class="left">
                      <div class="item select" style="width: 60px;">
                        <el-select v-model="i.LeftPart" clearable placeholder>
                          <el-option label="(" value="("></el-option>
                        </el-select>
                      </div>
                      <div class="item select">
                        <el-select v-model="i.MemberType" @change="changeMemberType(i)">
                          <el-option label="人员" :value="0"></el-option>
                          <el-option label="部门" :value="1"></el-option>
                          <el-option label="职务" :value="2"></el-option>
                          <el-option label="标签" :value="3"></el-option>
                        </el-select>
                      </div>
                      <div class="item" style="width: 40px;text-align: center;line-height: 28px;">
                        <span>{{i.OperatorText}}</span>
                      </div>
                      <div class="item" style="width: 400px;">
                        <el-tooltip
                          :disabled="i.MemberNames==''"
                          :content="i.MemberNames"
                          placement="top"
                        >
                          <select-input
                            :label="i.MemberNames"
                            v-model="i.MemberIds"
                            @click="openConstant(i)"
                            @clear="i.MemberNames=''"
                          />
                        </el-tooltip>
                      </div>
                      <div class="item select" style="width: 60px;">
                        <el-select v-model="i.RightPart" clearable placeholder>
                          <el-option label=")" value=")"></el-option>
                        </el-select>
                      </div>
                      <div class="item select" style="width: 60px;">
                        <el-select v-model="i.ConditionOperator" placeholder>
                          <el-option label="和" value="和"></el-option>
                          <el-option label="或" value="或"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="right">
                      <el-link @click="delCondition(key)" :underline="false">
                        <i class="el-icon-circle-close" />
                      </el-link>
                    </div>
                  </div>
                </template>
                <template v-if="select.Node.NodeType==1">
                  <el-divider></el-divider>
                  <div style="width: 260px;">
                    <div class="row-tb-head">
                      <span style="font-weight: bold;">同时有多个人员审批时</span>
                    </div>
                    <div style="margin-bottom: 10px;margin-left: 16px;">
                      <el-radio v-model="select.Node.MultiMode" :label="0">或签（一名人员同意即可）</el-radio>
                    </div>
                    <div style="margin-bottom: 10px;margin-left: 16px;">
                      <el-radio v-model="select.Node.MultiMode" :label="1">会签（须所有人员同意）</el-radio>
                    </div>
                    <el-form-item label="驳回方式">
                      <el-select v-model="select.Node.RejectMode">
                        <el-option label="不能驳回" :value="0"></el-option>
                        <el-option label="驳回至上一节点" :value="1"></el-option>
                        <el-option label="驳回至申请人" :value="2"></el-option>
                        <el-option label="审批人选择驳回节点" :value="3"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </template>
              </div>
              <div v-if="select.Node.NodeType==3">
                
              </div>
            </template>
            <template v-else>
              <el-divider style="margin: 11px 0px;"></el-divider>
              <div v-if="select.Flow.IsDefault"></div>
              <div v-else>
                <div style="margin-bottom: 5px;">
                  <el-button type="primary" plain @click="addCondition">添加条件</el-button>
                </div>
                <div v-for="(i,key) in select.FlowConditions" :key="key" class="conditions">
                  <div class="left">
                    <div class="item select" style="width: 60px;">
                      <el-select v-model="i.LeftPart" clearable placeholder>
                        <el-option label="(" value="("></el-option>
                      </el-select>
                    </div>
                    <div class="item select" style="width: 90px;">
                      <el-select v-model="i.VarType" @change="setType($event,i)">
                        <el-option label="表单" :value="0"></el-option>
                        <el-option label="申请人" :value="1"></el-option>
                        <el-option label="审批人" :value="2"></el-option>
                      </el-select>
                    </div>
                    <div class="item select" style="width: 120px;">
                      <template v-if="i.VarType==0">
                        <el-select v-model="i.FormItemId" @change="setForm($event,i)">
                          <template v-for="(i,fkey) in FormItems">
                            <el-option :key="fkey" :label="i.ItemName" :value="i.FormItemId"></el-option>
                          </template>
                        </el-select>
                      </template>
                      <template v-else>
                        <el-select v-model="i.MemberType" @change="changeMemberType(i)">
                          <el-option label="人员" :value="0"></el-option>
                          <el-option label="部门" :value="1"></el-option>
                          <el-option label="职务" :value="2"></el-option>
                          <el-option label="标签" :value="3"></el-option>
                        </el-select>
                      </template>
                    </div>
                    <div class="item" style="width: 100px;">
                      <template v-if="i.VarType==0">
                        <el-select v-model="i.Operator" @change="setOper($event,i)">
                          <el-option label="大于等于" value=">=" v-if="onIf(i)"></el-option>
                          <el-option label="大于" value=">" v-if="onIf(i)"></el-option>
                          <el-option label="等于" value="="></el-option>
                          <el-option label="小于等于" value="<=" v-if="onIf(i)"></el-option>
                          <el-option label="小于" value="<" v-if="onIf(i)"></el-option>
                        </el-select>
                      </template>
                      <el-select v-model="i.Operator" @change="setOper($event,i)" v-else>
                        <el-option label="等于" value="="></el-option>
                      </el-select>
                    </div>
                    <div class="item" style="width: 350px;" v-if="i.VarType==0">
                      <constant
                        :ref="'constant_'+key"
                        :component-type="i.ComponentType"
                        :item-type="i.ItemType"
                        :options="LeaveTypes"
                        KeyId="LeaveTypeName"
                        multiple
                        v-model="i.Constant"
                        @change1="setConstant1($event,i,'LeaveType')"
                      />
                    </div>
                    <div class="item" style="width: 350px;" v-else>
                      <el-tooltip
                        :disabled="i.ConstantText==''"
                        :content="i.ConstantText"
                        placement="top"
                      >
                        <select-input
                          :label="i.ConstantText"
                          v-model="i.Constant"
                          @click="openConstant(i)"
                          @clear="i.ConstantText=''"
                        />
                      </el-tooltip>
                    </div>
                    <div class="item select" style="width: 60px;">
                      <el-select v-model="i.RightPart" clearable placeholder>
                        <el-option label=")" value=")"></el-option>
                      </el-select>
                    </div>
                    <div class="item select" style="width: 60px;">
                      <el-select v-model="i.ConditionOperator" placeholder>
                        <el-option label="和" value="和"></el-option>
                        <el-option label="或" value="或"></el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="right">
                    <el-link @click="delCondition(key)" :underline="false">
                      <i class="el-icon-circle-close" />
                    </el-link>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </template>
    <template slot="footer" slot-scope="{isLoading}">
      <el-button type="primary" :loading="isLoading" @click="save">保存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
    <teacher-dialog ref="teacherDialog" in-dialog selectable multiple @select-multiple="setMember" />
    <dp-dialog ref="dpDialog" in-dialog selectable multiple @select-multiple="setDp" />
    <job-dialog ref="jobDialog" in-dialog selectable multiple @select-multiple="setJob" />
    <tags-dialog ref="tagsDialog" in-dialog selectable multiple @select-multiple="setTags" />
    <div style="position:relative;">
      <!-- <form-build></form-build> -->
      <!-- <flow></flow> -->
    </div>
  </common-dialog>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import nodeTree from "./nodeTree";
import teacherDialog from "./teacher/listDialog";
import dpDialog from "./dp/listDialog";
import jobDialog from "@/components/fa/job/listDialog";
import tagsDialog from "@/components/sys/basic/tags/listDialog";
import constant from "./constant";
// import flow from "@/views/flow";

export default {
  mixins: [editDialogMixin],
  components: {
    // flow,
    commonDialog,
    nodeTree,
    teacherDialog,
    dpDialog,
    jobDialog,
    tagsDialog,
    constant,
  },
  computed: {},
  data() {
    return {
      api: require("@/api/wf/process").default,
      leave_type_api: require("@/api/ent/leaveType").default,
      data: {
        ProcessId: "00000000-0000-0000-0000-000000000000",
        ProcessName: "",
        Description: "",
        CopyId: null,
        IsTemplate: false,
        Version: {
          FormItems: [],
          Configs: [],
          RootNode: null,
          ExceptionNode: null,
        },
        History: [],
        VersionId: "",
        Sort: 0,
        Status: 1,
      },
      TopTip:
        "修改流程设置时，保存后如果最新版本设置已经有申请数据，则会生成一个新的版本设置，<br />已提交的申请按旧的版本设置流转，后续新提交的申请则按新的版本设置流转",
      FormItems: [],
      select: {
        ChildNodes: [],
        Flow: {
          FlowName: "",
          FromId: "00000000-0000-0000-0000-000000000000",
        },
        FlowConditions: [],
        MemberConditions: [],
        Members: [],
        Node: {
          NodeName: "", //名称
          NodeType: 0, //申请人/审批/抄送/条件分支 99流程结束
          BaseMode: 0, //指定维度/指定部门负责人/连续多级部门负责人/申请人本人/申请人自选 99条件组合
          CanTurn: false, //能否转审
          DirectorDirection: 0, //从下至上/从上至下
          DirectorLv: 1, //1:直接部门负责人(从下至上) 最高部门负责人(从上至下)/2:第二级部门负责人
          MultiMode: 0, //多人审批方式 - 或签（一名人员同意即可）会签（须所有人员同意）依次审批（按顺序依次审批）
          RejectMode: 0, //驳回方式 - 不能驳回/驳回至上一节点/驳回至申请人/审批人选择驳回节点
          //全选/单选/多选
          //不选择/申请人审批人单选/申请人审批人多选
          //不选择人员（提交至所有人员）/单选人员（申请人、审批人选择一名人员）/多选人员（申请人、审批人选择多名人员）
          SelectMode: 0,
          Sort: 0,
        },
        Permissions: [],
        TreeNodeId: null,
        TreeNodeType: 0,
      },
      rules: {
        ProcessName: [{ required: true, message: "流程名称不能为空" }],
      },
      LeaveTypes: [],
      current: null,
      LvList: [],
    };
  },
  methods: {
    onCreateOpened(data) {
      // console.log("创建", data);
      this.isEdit = false;
      if (!data.IsCopy) {
        this.data = { ...this.data, ...data };
        this.getData(data.CopyId);
      } else {
        this.data.ProcessId = "00000000-0000-0000-0000-000000000000";
        this.data.ProcessName = "";
        this.data.CopyId = data.CopyId ? data.CopyId : data.ProcessId;
        this.$refs.dialog.clearValidate();
        this.getData(data.ProcessId);
      }
      this.api.getMaxSort().then((res) => {
        this.data.Sort = res.Data;
      });
    },
    onEditOpened(data) {
      this.isEdit = true;
      // console.log("编辑", data);
      this.data = { ...this.data, ...data };
      this.data.ProcessName = data.ProcessName;
      this.$refs.dialog.clearValidate();
      this.getData(data.ProcessId);
    },
    onReload(data) {
      this.$refs.dialog.isLoading = true;
      Object.assign(this.$data.select, this.$options.data().select);
      this.$refs.nodeTree.clear();
      this.api.getTreeVersion(data).then((res) => {
        this.$refs.dialog.isLoading = false;
        this.data.ProcessId = res.Data.ProcessId;
        this.data.History = res.Data.History;
        var version = res.Data.Version;
        this.data.Version.Configs = version.Configs.map((x) => {
          return { ...x, OptionArr: x.Options ? x.Options.split(",") : [] };
        });
        this.FormItems = version.FormItems.filter(
          (x) => x.ItemName == "请假类型" || x.ItemName == "请假时长"
        );
        this.data.Version.FormItems = version.FormItems;
        this.$refs.nodeTree.init([version.ExceptionNode, version.RootNode]);
      });
    },
    getData(id) {
      this.$refs.dialog.isLoading = true;
      this.api.getTreeProcess(id).then((res) => {
        this.$refs.dialog.isLoading = false;
        this.data.History = res.Data.History;
        this.data.VersionId = res.Data.VersionId;
        var version = res.Data.Version;
        this.data.Version.Configs = version.Configs.map((x) => {
          return { ...x, OptionArr: x.Options ? x.Options.split(",") : [] };
        });
        this.FormItems = version.FormItems.filter(
          (x) => x.ItemName == "请假类型" || x.ItemName == "请假时长"
        );
        this.data.Version.FormItems = version.FormItems;
        this.$refs.nodeTree.init([version.ExceptionNode, version.RootNode]);
      });
    },
    onOpened() {
      this.leave_type_api.list({}).then((res) => {
        this.LeaveTypes = res.Data;
      });

      for (let i = 2; i <= 10; i++) {
        this.LvList.push({
          label: this.setText(i),
          value: i,
        });
      }
    },
    setText(value) {
      if (value == 2) return "第二";
      if (value == 3) return "第三";
      if (value == 4) return "第四";
      if (value == 5) return "第五";
      if (value == 6) return "第六";
      if (value == 7) return "第七";
      if (value == 8) return "第八";
      if (value == 9) return "第九";
      if (value == 10) return "第十";
    },
    onSelect(data) {
      console.log("onSelect", JSON.parse(JSON.stringify(data)));

      // this.select = JSON.parse(JSON.stringify(data));
      this.select = data;
      if (this.select.Node) {
        if (this.select.Node.DirectorLv == 0) this.select.Node.DirectorLv = 1;
      }
      if (data.FlowConditions) {
        this.$nextTick(() => {
          data.FlowConditions.forEach((x, i) => {
            if (x.VarType == 0) {
              if (this.$refs["constant_" + i][0]) {
                this.$refs["constant_" + i][0].init(x.Constant);
              }
            }
          });
        });
      }
    },
    onCommand(e) {
      console.log("onCommand", e);
      switch (e) {
        case 0: //人员
          this.$refs.teacherDialog.open().then((that) => {
            that.getData();
          });
          break;
        case 1: //部门
          this.$refs.dpDialog.open().then((that) => {
            that.getData();
          });
          break;
        case 2: //职务
          this.$refs.jobDialog.open().then((that) => {
            that.getData();
          });
          break;
        case 3: //标签
          this.$refs.tagsDialog.open().then((that) => {
            that.getData();
          });
          break;
      }
    },
    setMember(data) {
      console.log("设置人员", data);
      if (this.select.TreeNodeType == 0) {
        if (this.select.Node.BaseMode != 99) {
          data.forEach((x) => {
            this.select.Members.push({
              MemberId: x.TeacherId,
              MemberName: x.TeacherName,
              MemberType: 0,
              MemberTypeName: "人员",
            });
          });
        } else {
          var ids = data.map((x) => x.TeacherId);
          this.current.MemberIds = ids.join(",");
          var names = data.map((x) => x.TeacherName);
          this.current.MemberNames = names.join(",");
        }
      } else {
        var ids = data.map((x) => x.TeacherId);
        this.current.Constant = ids.join(",");
        var names = data.map((x) => x.TeacherName);
        this.current.ConstantText = names.join(",");
      }
    },
    setDp(data) {
      if (this.select.TreeNodeType == 0) {
        if (this.select.Node.BaseMode != 99) {
          data.forEach((x) => {
            this.select.Members.push({
              MemberId: x.DpId,
              MemberName: x.DpName,
              MemberType: 1,
              MemberTypeName: "部门",
            });
          });
        } else {
          var ids = data.map((x) => x.DpId);
          this.current.MemberIds = ids.join(",");
          var names = data.map((x) => x.DpName);
          this.current.MemberNames = names.join(",");
        }
      } else {
        console.log("设置部门", data);
        var ids = data.map((x) => x.DpId);
        this.current.Constant = ids.join(",");
        var names = data.map((x) => x.DpName);
        this.current.ConstantText = names.join(",");
      }
    },
    setJob(data) {
      if (this.select.TreeNodeType == 0) {
        if (this.select.Node.BaseMode != 99) {
          data.forEach((x) => {
            this.select.Members.push({
              MemberId: x.JobId,
              MemberName: x.JobName,
              MemberType: 2,
              MemberTypeName: "职务",
            });
          });
        } else {
          var ids = data.map((x) => x.JobId);
          this.current.MemberIds = ids.join(",");
          var names = data.map((x) => x.JobName);
          this.current.MemberNames = names.join(",");
        }
      } else {
        console.log("设置职务", data);
        var ids = data.map((x) => x.JobId);
        this.current.Constant = ids.join(",");
        var names = data.map((x) => x.JobName);
        this.current.ConstantText = names.join(",");
      }
    },
    setTags(data) {
      if (this.select.TreeNodeType == 0) {
        if (this.select.Node.BaseMode != 99) {
          data.forEach((x) => {
            this.select.Members.push({
              MemberId: x.TagId,
              MemberName: x.TagName,
              MemberType: 3,
              MemberTypeName: "标签",
            });
          });
        } else {
          var ids = data.map((x) => x.TagId);
          this.current.MemberIds = ids.join(",");
          var names = data.map((x) => x.TagName);
          this.current.MemberNames = names.join(",");
        }
      } else {
        console.log("设置标签", data);
        var ids = data.map((x) => x.TagId);
        this.current.Constant = ids.join(",");
        var names = data.map((x) => x.TagName);
        this.current.ConstantText = names.join(",");
      }
    },
    delMember(row, index) {
      this.select.Members.splice(index, 1);
    },
    addCondition() {
      if (this.select.TreeNodeType == 0) {
        var length = this.select.MemberConditions.length;
        this.select.MemberConditions.push({
          LeftPart: "", //左括号，可空 - (
          MemberType: 0, //申请人/审批人 - 人员/部门/职务/标签
          Operator: "=", //操作符 - =
          OperatorText: "等于", //操作符显示文本 - 等于
          MemberIds: "",
          MemberNames: "",
          RightPart: "", //右括号，可空 - )
          ConditionOperator: "和", //和/或 - 和 或 && ||
          Sort: length,
        });
      } else {
        var length = this.select.FlowConditions.length;
        var first = this.FormItems ? this.FormItems[0] : null;
        this.select.FlowConditions.push({
          // FlowConditionId: null,
          // FlowId: null,
          LeftPart: "", //左括号，可空 - (
          VarType: 0, //变量类型 - 表单/申请人/审批人
          FormItemId: first ? first.FormItemId : null, //表单项Id
          ComponentType: first ? first.ComponentType : null, //常用控件/请假组件
          //常用控件:0-99:文本/多行文本/说明文字 100-199:数字/整数 200-299:日期/日期+上下午/日期+时分 300-399:单选/多选 400-499:附件
          //请假组件:请假类型/开始时间/结束时间/请假时长/销假状态/实际结束时间/开始时间部分/结束时间部分/实际结束时间部分
          ItemType: first ? first.ItemType : null,
          MemberType: 0, //申请人/审批人 - 人员/部门/职务/标签
          Operator: "=", //操作符 - 数值:>= > = <= <
          OperatorText: "等于", //操作符显示文本 - 数值:大于等于 大于 等于 小于等于 小于
          Constant: "", //常量值 - 3,多个逗号分隔
          ConstantText: "", //常量值显示文本 - 小明,多个逗号分隔
          RightPart: "", //右括号，可空 - )
          ConditionOperator: "和", //和/或 - 和 或 && ||
          Expression: "",
          ExpressionText: "",
          Sort: length,
        });
        console.log("添加条件", this.select.FlowConditions);
      }
    },
    setType(e, row) {
      // console.log("setType", e);
      row.Operator = "=";
      row.OperatorText = "等于";
      row.Constant = "";
      row.ConstantText = "";
    },
    setForm(e, row) {
      var item = this.FormItems.find((x) => x.FormItemId == e);
      // console.log("item", item);
      row.ComponentType = item.ComponentType;
      row.ItemType = item.ItemType;
      row.Operator = "=";
      row.OperatorText = "等于";
    },
    onIf(row) {
      if (row.ComponentType == 0) {
        return row.ItemType >= 100 && row.ItemType <= 199;
      } else {
        return row.ItemType == 3;
      }
    },
    setOper(e, row) {
      switch (e) {
        case ">=":
          row.OperatorText = "大于等于";
          break;
        case ">":
          row.OperatorText = "大于";
          break;
        case "=":
          row.OperatorText = "等于";
          break;
        case "<=":
          row.OperatorText = "小于等于";
          break;
        case "<":
          row.OperatorText = "小于";
          break;
      }
    },
    setConstant1(data, row, type) {
      console.log("setConstant1", data, typeof data == "object");
      row.Constant = data;
      row.ConstantText = data;
    },
    changeMemberType(row) {
      if (this.select.TreeNodeType == 0) {
        row.MemberIds = "";
        row.MemberNames = "";
      } else {
        row.Constant = "";
        row.ConstantText = "";
      }
    },
    openConstant(row) {
      // console.log("open-constant", row);
      this.current = row;
      this.onCommand(row.MemberType);
    },
    delCondition(index) {
      if (this.select.TreeNodeType == 0) {
        this.select.MemberConditions.splice(index, 1);
      } else {
        this.select.FlowConditions.splice(index, 1);
      }
    },
    setDirector(e) {
      var dir = this.select.Node.DirectorDirection;
      var dir_lv = this.select.Node.DirectorLv;
      if (dir == 0) {
        if (dir_lv == 1) this.select.Node.NodeName = "直接部门负责人";
        else this.select.Node.NodeName = this.setText(dir_lv) + "级部门负责人";
      } else {
        if (dir_lv == 1) this.select.Node.NodeName = "最高部门负责人";
        else this.select.Node.NodeName = this.setText(dir_lv) + "层部门负责人";
      }
    },
    onConfirm() {
      // console.log("确定", this.select);
      this.$refs.nodeTree.onConfirm(this.select);
    },
    onCancel() {
      Object.assign(this.$data.select, this.$options.data().select);
    },
    save() {
      var node = JSON.parse(JSON.stringify(this.$refs.nodeTree.data[1]));
      // console.log("node", node);
      var can_save = true;
      var err_msg = "";
      var _this = this;
      function SetNodeId(childs) {
        childs.forEach((x) => {
          x.TreeNodeId = "00000000-0000-0000-0000-000000000000";
          if (x.TreeNodeType == 0) {
            if (x.Node.NodeType == 1 || x.Node.NodeType == 2) {
              if (x.Node.BaseMode == 99) {
                if (x.MemberConditions.length == 0) {
                  can_save = false;
                  err_msg += x.Node.NodeName + "：条件列表不能为空；";
                } else {
                  if (x.MemberConditions.some((x) => !x.MemberIds)) {
                    can_save = false;
                    err_msg += x.Node.NodeName + "：条件的值不能为空；";
                  }
                }
              }
              if (x.Node.BaseMode == 0 && x.Members.length == 0) {
                can_save = false;
                err_msg += x.Node.NodeName + "：成员列表不能为空；";
              }
            }
            x.Permissions = [];
            _this.data.Version.FormItems.forEach((i) => {
              var p = {
                FormItemId: i.FormItemId,
                FuncType: i.IsPublic ? 1 : 0,
              };
              if (x.Node.NodeId) p.NodeId = x.Node.NodeId;
              x.Permissions.push(p);
            });
          } else {
            // console.log("条件", x);
            if (!x.Flow.IsDefault) {
              if (x.FlowConditions.length == 0) {
                can_save = false;
                err_msg += x.Flow.FlowName + "：条件列表不能为空；";
              } else {
                if (x.FlowConditions.some((x) => !x.Constant)) {
                  can_save = false;
                  err_msg += x.Flow.FlowName + "：条件的值不能为空；";
                }
              }
            }
          }
          x = { ..._this.$commonJs.obj.removeNullKey(x) };
          if (x.ChildNodes) SetNodeId(x.ChildNodes);
        });
      }

      if (node.Members.length == 0) {
        can_save = false;
        err_msg += node.Node.NodeName + "：申请人成员列表不能为空；";
      }
      SetNodeId(node.ChildNodes);

      if (!can_save) {
        this.$message.warning(err_msg);
        return;
      }

      this.data.Version.RootNode = node;
      var exception = JSON.parse(JSON.stringify(this.$refs.nodeTree.data[0]));
      this.data.Version.ExceptionNode = exception;
      console.log("保存", JSON.parse(JSON.stringify(this.data)));

      this.$refs.dialog.isLoading = true;
      this.api.saveTreeProcess(this.data).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success("保存成功");
          this.$emit("close-saved");
          this.data.ProcessId = res.Data;
          // this.close(true);
          if (this.isEdit) {
            this.$refs.dialog.isChange = false;
            this.getData(res.Data);
          }
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      Object.assign(this.$data.select, this.$options.data().select);
      this.data.Version.FormItems = [];
      this.data.Version.Configs = [];
      this.LvList = [];
      this.$refs.nodeTree.clear();
    },
  },
};
</script>
<style lang="scss" scoped>
.form-item {
  width: 400px;
  display: inline-block;
}
.right-box {
  width: calc(100% - 370px);
  position: relative;
  .conditions {
    display: flex;
    .left {
      width: calc(100% - 50px);
      display: flex;

      .item + .item {
        margin-left: 5px;
      }
      .select {
        width: 90px;
      }
    }
    .right {
      text-align: center;
      width: 50px;
      line-height: 25px;
      .el-link.el-link--default {
        color: #f56c6c !important;
      }
    }
  }
  .conditions + .conditions {
    margin-top: 5px;
  }
}
</style>